'use strict';

app.controller('SettingsCtrl', [
    '$scope',
    '$rootScope',
    '$http',
    '$translate',
    '$ngConfirm',
    'toaster',
    '$localStorage',
    '$cookies',
    function($scope, $rootScope, $http, $translate, $ngConfirm, toaster, $localStorage, $cookies) {
        $scope.submitted = false;
        $scope.loading = false;
        $scope.distanceSources = ['can', 'gps', 'auto'];

        $scope.settings = {};
        $scope.objects = angular.copy($scope.extractAllUserObjects(true, false));
        $scope.groups = [];
        $scope.groupsAndObjects = angular.copy($scope.extractAllUserGroupsAndObjects(true));

        $scope.selected = {
            objects: {
                unplug: [],
                tanks: [],
                distanceSource: 'auto',
            },
        };

        $scope.daysOfWeek = moment.weekdaysShort();
        $scope.daysOfWeek.push($scope.daysOfWeek.shift());

        $scope.api = {
            speed: false,
            engine: false,
        };

        $scope.distance_worktime = {
            collection: [],
            empty: $scope.daysOfWeek.map(function() {
                return { status: 0 };
            }),
            day: [],
            object: false,
            choosen: [],
        };

        $scope.vat = {
            collection: [],
            data: {
                day: '',
                milage: '',
            },
            object: false,
        };

        $scope.vat.empty = angular.copy($scope.vat.data);

        $scope.disabled = {
            notifications: true,
        };

        $scope.choosenVatObjects = [];

        $scope.settingsByExtraFeatures = function() {
            var notifications = ['speed', 'engine', 'service', 'voltage', 'temperature', 'rpm', 'unplug', 'refueling'];
            for (var n in notifications) {
                var notification = notifications[n];
                var disabled = $scope.app.user.extraFeatures.indexOf('login-notifications-' + notification) < 0 ? 1 : 0;

                $scope.settings.notifications[notification].disabled = disabled;
                if (!disabled) {
                    $scope.disabled.notifications = false;
                } else {
                    $scope.settings.notifications[notification].on = 0;
                }
            }
        };

        $scope.isSubmitted = function() {
            return $scope.submitted;
        };

        $scope.getSettings = function() {
            return $http.get('/api/userSetting').then(
                function(response) {
                    var args = typeof response.data.data !== 'undefined' ? response.data.data.args : {};

                    $scope.settings = args;
                    $scope.buildSettings(args);

                    $scope.submitted = false;
                },
                function() {
                    toaster.pop(
                        'error',
                        $translate.instant('settings.toastr.error.header'),
                        $translate.instant('settings.toastr.error.get')
                    );
                    $scope.submitted = true;
                }
            );
        };

        var splitStringIntoCollection = function(source) {
            var objs = source == '' ? [] : source.split(',');

            return objs.map(function(obj) {
                return parseInt(obj);
            });
        };

        $scope.buildSettings = function(args) {
            $scope.selected.objects.unplug = splitStringIntoCollection(args.notifications.unplug.objects);
            $scope.selected.objects.tanks = splitStringIntoCollection(args.fuel.tanks.objects);

            /*
             * time work range section
             */

            if (typeof $scope.settings.reports.distance_worktime === 'undefined') {
                $scope.settings.reports.distance_worktime = {
                    objects: [],
                };
            }

            $scope.distance_worktime.collection = $scope.settings.reports.distance_worktime.objects;
            $scope.updateChoosenObjectsGeneral('distance_worktime');

            $scope.vat.collection = $scope.settings.reports.vat.objects;
            $scope.updateChoosenVatObjects();

            if ($scope.settings.distanceSource !== void 0) {
                $scope.selected.distanceSource = $scope.settings.distanceSource;
            }
        };

        var reloadUserSettings = function() {
            $http.get('/api/auth').then(function(data) {
                var authenticated = ((data || {}).data || {}).data || {};

                if (authenticated.loginId !== void 0) {
                    $rootScope.$broadcast('updateUserData', authenticated);
                }
            });
        };

        $scope.saveSettings = function() {
            if ($scope.settingsFrom.$invalid) {
                toaster.pop({
                    type: 'error',
                    title: $translate.instant('general.toastr.error.header'),
                    body: $translate.instant('error.InvalidForm'),
                });

                return false;
            }

            $scope.buildPayload();

            $scope.submitted = true;
            $http.post('/api/userSetting', $scope.settings).then(
                function() {
                    toaster.pop(
                        'success',
                        $translate.instant('settings.toastr.success.header'),
                        $translate.instant('settings.toastr.success.saved')
                    );
                    $scope.submitted = false;

                    /**
                     * remove harmonograms authentication -
                     * cookies + local storage
                     */
                    delete $localStorage.csrf;
                    $cookies.remove('jwt_access');

                    reloadUserSettings();
                },
                function() {
                    toaster.pop(
                        'error',
                        $translate.instant('settings.toastr.error.header'),
                        $translate.instant('settings.toastr.error.saved')
                    );
                    $scope.submitted = false;
                }
            );
        };

        $scope.updateChoosenVatObjects = function() {
            $scope.choosenVatObjects = [];
            for (var obj in $scope.vat.collection) {
                var o = $scope.vat.collection[obj];
                var changed = false;
                for (var i in o.data) {
                    if (o.data[i]) {
                        var changed = true;
                        break;
                    }
                }
                if (changed) {
                    $scope.choosenVatObjects.push(o.id);
                }
            }
        };

        $scope.updateChoosenObjectsGeneral = function(reference) {
            $scope[reference].choosen = [];
            for (var obj in $scope[reference].collection) {
                var o = $scope[reference].collection[obj];
                for (var i in o.dates) {
                    if (o.dates[i].status > 0) {
                        $scope[reference].choosen.push(o.id);
                        break;
                    }
                }
            }
        };

        $scope.isChoosenGeneral = function(o, reference) {
            var value = o.type === 'group' ? 'g' + o.groupId : o.objectId;
            return $scope[reference].choosen.indexOf(value) >= 0;
        };

        $scope.goToObjectGeneral = function(o, reference) {
            $scope[reference].object = JSON.stringify(o);
        };

        $scope.compareChoosenGeneral = function(o, reference) {
            var selected = JSON.parse($scope[reference].object);
            var field = o.type === 'group' ? 'groupId' : 'objectId';

            return o[field] == selected[field];
        };

        $scope.removeEmptiesGeneral = function(reference) {
            $scope[reference].collection = $scope[reference].collection.filter(function(o) {
                var empty = true;
                for (var i in o.dates) {
                    if (o.dates[i].status > 0) {
                        empty = false;
                    }
                }
                return !empty;
            });
        };

        $scope.updateTimeRangeGeneral = function(n, o, reference) {
            if (o) {
                o = JSON.parse(o);
                var push = true;
                var cv = o.type === 'group' ? 'g' + o.groupId : o.objectId;

                for (var obj in $scope[reference].collection) {
                    if ($scope[reference].collection[obj].id === cv) {
                        $scope[reference].collection[obj].dates = angular.copy($scope[reference].day);
                        push = false;
                        break;
                    }
                }

                if (push) {
                    $scope[reference].collection.push({
                        id: cv,
                        dates: angular.copy($scope[reference].day),
                    });
                }
            }

            if (n) {
                n = JSON.parse(n);
                var cv = n.type === 'group' ? 'g' + n.groupId : n.objectId;

                $scope[reference].day = angular.copy($scope[reference].empty);

                for (var obj in $scope[reference].collection) {
                    if ($scope[reference].collection[obj].id === cv) {
                        $scope[reference].day = $scope[reference].collection[obj].dates;
                    }
                }
            }

            $scope.updateChoosenObjectsGeneral(reference);
        };

        $scope.updateVatObject = function(n, o) {
            if (o) {
                o = JSON.parse(o);
                var push = true;

                for (var obj in $scope.vat.collection) {
                    if ($scope.vat.collection[obj].id === o.objectId) {
                        $scope.vat.collection[obj].data = angular.copy($scope.vat.data);
                        push = false;
                        break;
                    }
                }

                if (push) {
                    $scope.vat.collection.push({
                        id: o.objectId,
                        data: angular.copy($scope.vat.data),
                    });
                }
            }

            if (n) {
                n = JSON.parse(n);
                $scope.vat.data = angular.copy($scope.vat.empty);

                for (var obj in $scope.vat.collection) {
                    if ($scope.vat.collection[obj].id === n.objectId) {
                        $scope.vat.data = $scope.vat.collection[obj].data;
                    }
                }
            }

            $scope.updateChoosenVatObjects();
        };

        $scope.$watch('vat.object', function(n, o) {
            $scope.updateVatObject(n, o);
        });

        $scope.$watch('distance_worktime.object', function(n, o) {
            $scope.updateTimeRangeGeneral(n, o, 'distance_worktime');
        });

        $scope.resetTimeRangeDistanceWorktime = function(day) {
            if ($scope.distance_worktime.day[day].status === 0) {
                $scope.distance_worktime.day[day].status = 1;
                $scope.distance_worktime.day[day].start = '00:00';
                $scope.distance_worktime.day[day].end = '23:59';
            } else {
                $scope.distance_worktime.day[day].status = 0;
                delete $scope.distance_worktime.day[day].start;
                delete $scope.distance_worktime.day[day].end;
                delete $scope.distance_worktime.day[day].start2;
                delete $scope.distance_worktime.day[day].end2;
            }
        };

        var implodeCollection = function(source) {
            var objs =
                source.length > 0
                    ? source
                          .map(function(o) {
                              return o.type === 'group' ? 'g' + o.groupId : o.objectId;
                          })
                          .join(',')
                    : '';

            return objs;
        };

        $scope.buildPayload = function() {
            $scope.settings.notifications.unplug.objects = implodeCollection($scope.selected.objects.unplug);
            $scope.settings.fuel.tanks.objects = implodeCollection($scope.selected.objects.tanks);

            if ($scope.api.engine) {
                $scope.api.engine.build();
            }

            if ($scope.api.speed) {
                $scope.api.speed.build();
            }

            /*
             * Distance worktime report
             */
            $scope.updateTimeRangeGeneral(false, $scope.distance_worktime.object, 'distance_worktime');
            $scope.removeEmptiesGeneral('distance_worktime');

            for (var i in $scope.distance_worktime.collection) {
                for (var j in $scope.distance_worktime.collection[i].dates) {
                    var o = $scope.distance_worktime.collection[i].dates[j];
                    if (!(o !== null && typeof o === 'object')) {
                        $scope.distance_worktime.collection[i].dates[j] = false;
                    }
                }
            }

            $scope.settings.reports.distance_worktime.objects = $scope.distance_worktime.collection;

            /*
             * Vat report
             */
            $scope.updateVatObject(false, $scope.vat.object);
            $scope.settings.reports.vat.objects = $scope.vat.collection;
            $scope.settings.distanceSource = $scope.selected.distanceSource;
        };

        var validatePassword = function(v) {
            var regex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{7,})');
            return regex.test(v);
        };

        var updateLoginPassword = function(id) {
            if (!validatePassword($scope.password.new)) {
                toaster.pop(
                    'error',
                    $translate.instant('settings.toastr.error.header'),
                    $translate.instant('settings.toastr.error.saved')
                );
                return false;
            }
            if ($scope.password.new !== $scope.password.repeat) {
                toaster.pop(
                    'error',
                    $translate.instant('general.toastr.error.header'),
                    $translate.instant('logins.toastr.error.password-match')
                );
                return false;
            }

            var payload = { comment: $scope.password.new, id: id };
            $http.post('/api/login/password', payload).then(
                function() {
                    toaster.pop(
                        'success',
                        $translate.instant('general.toastr.success.header'),
                        $translate.instant('general.toastr.success.form.action.update')
                    );
                },
                function() {
                    toaster.pop(
                        'error',
                        $translate.instant('general.toastr.error.header'),
                        $translate.instant('general.toastr.error.form.action.update')
                    );
                }
            );
            return true;
        };

        $scope.password = {};
        $scope.updateLoginPasswordPrompt = function() {
            var login = $rootScope.app.user;
            $scope.password = {};
            $scope.user = login.user + '@' + login.code;

            $ngConfirm({
                title: $translate.instant('logins.password.header'),
                contentUrl: 'tpl/pages/logins/modals/password.html',
                animation: 'rotate',
                theme: 'supervan',
                columnClass: 'medium',
                icon: 'pe-7s-lock pe-lg pe-va',
                scope: $scope,
                buttons: {
                    yes: {
                        text: $translate.instant('general.confirm.save.ok'),
                        btnClass: 'btn-danger',
                        action: function(scope) {
                            return updateLoginPassword(login.loginId);
                        },
                    },
                    no: {
                        text: $translate.instant('general.confirm.save.cancel'),
                        btnClass: 'btn-dark',
                    },
                },
            });
        };

        $scope.harmonogramSignIn = function() {
            var payload = $scope.settings.harmonograms;

            $http.post('/api/harmonogram/auth', payload).then(
                function() {
                    toaster.pop(
                        'success',
                        $translate.instant('general.toastr.success.header'),
                        $translate.instant('settings.toastr.success.harmonogram')
                    );
                },
                function() {
                    toaster.pop(
                        'error',
                        $translate.instant('general.toastr.error.header'),
                        $translate.instant('settings.toastr.error.harmonogram')
                    );
                }
            );
        };

        $scope.init = function() {
            $scope.getSettings().then(function() {
                $scope.settingsByExtraFeatures();
                $scope.loading = true;
            });
        };
        $scope.init();
    },
]);
